<section class="centered-with-padding pb-14">
  <div class="grid grid-cols-1 gap-5 desk:grid-cols-2">
    @if (tutos(); as data) {
      @for (tuto of data.tutos; track $index) {
        <a
          [routerLink]="tuto.url"
          class="group relative block h-[416px] w-full overflow-hidden rounded-3xl desk:h-[400px]">
          @if (tuto.image; as image) {
            <app-image
              [hoverEffect]="true"
              [image]="image"
              [isPriority]="!isImageInPreviousBlocks && $index < 2"
              [pregenerationSize]="{ width: 530, height: 416 }" />
          }
          <div class="absolute left-1/2 top-[85px] -translate-x-1/2 desk:top-[105px]">
            <app-svg [hasShadowCta]="true" [height]="58" [src]="'assets/icons/player.svg'" [width]="58" />
          </div>
          <div class="absolute inset-x-2.5 bottom-2.5 grid grid-cols-1 gap-y-2 rounded-[20px] bg-gray-light p-5">
            <div class="grid grid-cols-[1fr_auto] items-center gap-x-9">
              <span class="text-[18px] font-bold leading-5 tracking-[-0.36px]">{{ tuto.title }}</span>
              <div class="w-[23px]">
                <app-svg [height]="17" [width]="23" src="./assets/icons/arrow-right.svg" />
              </div>
            </div>
            <span class="line-clamp-6 desk:line-clamp-4">{{ tuto.text }}</span>
          </div>
        </a>
      }
    }
  </div>
</section>
